import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { LockChip } from '../../components/LockedControl/LockedControl';
import { useUpgradePrompt } from '../../hooks/useUpgradePrompt';
import type { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseSearch.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseLockedFilterProps {
  label: string;
  value: string;
  feature: SMLUpgradeFeature;
}

/**
 * A filter the plan does not open (owner answer 3): Country below Manager, Service below Label.
 * It stays clickable and opens the plan prompt; the chip names the plan that opens it (design a1).
 */
const BrowseLockedFilterComponent: React.FC<BrowseLockedFilterProps> = ({ label, value, feature }) => {
  const openUpgrade = useUpgradePrompt();
  return (
    <button
      type="button"
      className={clsx(styles.dropdown, styles.dropdownLocked)}
      onClick={() => openUpgrade(feature)}
      data-testid={`browse-locked-${feature}`}
    >
      <span>{label}</span>
      <b>{value}</b>
      <LockChip feature={feature} withSpokenHint />
    </button>
  );
};

export const BrowseLockedFilter = TypedMemo(BrowseLockedFilterComponent);
